/**
 * The vendor's audit (container, phase 7b): two tabs — the vendor's own
 * actions (`GET /vendor/activity`, live through the change kinds that write
 * it) and every tenant's break-glass audit (`GET /vendor/audit`, D20) — each
 * paged with "Load more".
 */
import { useVendorActivity, useVendorAudit } from '../app/hooks.js';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs.js';
import { ActivityLog } from '../components/vendor/ActivityLog.js';
import { VendorAuditTable } from '../components/vendor/VendorAuditTable.js';

function messageOf(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

export function VendorAuditView() {
  const activity = useVendorActivity();
  const audit = useVendorAudit();
  return (
    <Tabs defaultValue="activity">
      <TabsList>
        <TabsTrigger value="activity">Vendor actions</TabsTrigger>
        <TabsTrigger value="break-glass" data-testid="audit-break-glass-tab">
          Break-glass (all tenants)
        </TabsTrigger>
      </TabsList>
      <TabsContent value="activity" className="pt-4">
        <ActivityLog
          entries={activity.data?.pages.flatMap((p) => p.entries) ?? []}
          loading={activity.isFetching}
          error={activity.error === null ? null : messageOf(activity.error)}
          hasMore={activity.hasNextPage}
          onMore={() => void activity.fetchNextPage()}
        />
      </TabsContent>
      <TabsContent value="break-glass" className="pt-4">
        <VendorAuditTable
          entries={audit.data?.pages.flatMap((p) => p.entries) ?? []}
          loading={audit.isFetching}
          error={audit.error === null ? null : messageOf(audit.error)}
          hasMore={audit.hasNextPage}
          onMore={() => void audit.fetchNextPage()}
        />
      </TabsContent>
    </Tabs>
  );
}
